<template>
   <div>
      <div class="card my-3 my-md-5">
         <div class="card-body">
            <b-row class="mx-1">
               <h3 class="pb-2 mb-3">Sperrlisten Export</h3>
               <b-input-group>
                  <b-input-group-prepend>
                     <b-input-group-text>
                        <span>SSI-Cutoff</span>
                     </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="number" min="0" v-model="ssiCutoff"/>     
                  <b-button v-if="limitToLagerVendors" size="sm" @click="limitToLagerVendors = false" class="ml-2" variant="success">
                     <span class="icon icon-checkmark"> mit Lagerbeschränkung</span>
                  </b-button>
                  <b-button v-else size="sm" @click="limitToLagerVendors = true" class="ml-2">
                     <span class="icon icon-minus"> ohne Lagerbeschränkung</span>
                  </b-button>
                  <b-button variant="primary" @click="fetchBlockedMaterials()" class="ml-2">Export generieren</b-button>
               </b-input-group>
            </b-row>
         </div>
      </div>
      <div class="card my-3 my-md-5">
         <div class="card-body">
               <h3 class="pb-2 mb-3">Blocker Manual Sperrlisten Export</h3>
            <div class="d-flex justify-content-center">
               <b-form-textarea rows="5" class="col" v-model="asinTextArea"/>                 
               <b-button variant="primary" @click="getBlockerManualList()" class="ml-2 mt-auto float-right">Export generieren</b-button>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import axios from 'axios';
export default {
   data() {
      return {
         marketAccounts: [],
         ssiCutoff: 1,
         limitToLagerVendors: true,
         blockedMaterialData: null,
         fields: [
            { key: "materialIdFirst", label: "Material ID" },
            { key: "materialIdSecond", label: "Material ID" },
            {
               key: "created_at",
               label: "erstellt am",
               formatter: function(s) { return s ? moment(s).format("DD.MM.YYYY HH:mm") : "‒" }
            },
            { key: "actions", label: "Jobzustand" }
         ],
         asinTextArea: '',
         countries: [],
         regions: [],
         marktets: [],
      };
   },
   watch: {
      blockedMaterialData: function(data) {
         if(!data) return;
         this.execute(data);
      }
   },
   methods: {
      /**
       * COPIED FROM MaterialStockListingsEditor!
       * TODO this should be put into Array.prototype.groupBy somewhere when Vue is initiated!
       * groups array of objects by a specific key-value pair.
       * @param xs: array<T>
       * @param k: string,  such that: k <- Object.keys(T)
       * @return { ...key: array<T> }
       */
      groupBy: function(xs, key) {
         return xs.reduce(function(rv, x) { (rv[x[key]] = rv[x[key]] || []).push(x); return rv; }, {});
      },
      groupByFlat: function(xs, key) {
         return Object.values(this.groupBy(xs, key));
      },
      formatRegion(blocker){
         if(!blocker || blocker.asin === "Freigaben") return;
         if(blocker.countryId){
            const country = this.countries.find(country => country.id === blocker.countryId);
            return country?.name
         } else if(blocker.marketId) {
            const market = this.markets.find(market => market.id === blocker.marketId);
            return market?.name
         } else if(blocker.regionId){
            const region = this.regions.find(region => region.id === blocker.regionId);
            return region?.name
         }
      },
      fetchBlockedMaterials() {
         const payload = {
            ssiCutoff: this.ssiCutoff,
            limitToLagerVendors: this.limitToLagerVendors
         };
         this.blockedMaterialData = null;
         axios.post("/material/generate_blocked_material_list", payload).then( ({data}) => {
            this.blockedMaterialData = data;
         }).catch( error => {
            this.$bvToast.toast( "Sperrlisten-Erstellung ist Serverseitig fehlgeschlagen.", {
               title: "Sperrlisten-Export",
               autoHideDelay: 8000,
               appendToast: false,
               variant: 'danger'
            });
            console.error(error);
         });
      },
      execute(data)
      {
         // we determine which marketAccounts even are listed, 
         // and only create columns accordingly (or else we end up with way too many cols).
         const marketAccountColumns = data.map( row => {
            const maybe = this.marketAccounts.find( x => x.id == row.marketAccountId);
            return {
               id: row.marketAccountId,
               name: "SSI_" + (maybe ? maybe.name : row.marketAccountId)
            };
         }).sort( (v,w) => v.id - w.id );

         const excelRows =  this.groupByFlat(data, "materialId").map( partition => {
            const any = partition[0];
            let excelRow = {
               "Material-ID": any.materialId,
               "EAN": any.ean,
               "ASIN": any.asin
            };
            // "maCol" abbreviated "marketAccountColumn"
            for(let maCol of marketAccountColumns) {
               const maybe = partition.find( material => material.marketAccountId == maCol.id);
               excelRow[maCol.name] = maybe ? maybe.ssi : 0;
            }
            return excelRow;
         });

         const worksheet = XLSX.utils.json_to_sheet(excelRows);
         const workbook = XLSX.utils.book_new();

         XLSX.utils.book_append_sheet(workbook, worksheet, "main");
         XLSX.writeFile(workbook, "shit.xlsx");
      },
      getBlockerManualList(){
         const payload = {
            asinText : this.asinTextArea,
         }
         axios.post('/material/get_blocker_manual_list', payload)
         .then(res => {
            console.log(res.data);
            let blockerManuals = res.data;

            const mappedBlockerManuals = blockerManuals.map(blocker => {
               return {
                  ASIN: blocker.asin,
                  Grund: blocker.reason,
                  Region: this.formatRegion(blocker),
                  Typ: blocker.blackOrWhite ? "Sperrung" : "Freigabe"
               }
            })
            console.log(mappedBlockerManuals);
            Vue.nextTick().then(() => {
               const currentDate = moment().format('DD-MM-YYYY')
               const ws = XLSX.utils.json_to_sheet(mappedBlockerManuals);
               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Materials");
               XLSX.writeFile(wb, "BlockerManualExport_" + currentDate + ".xlsx");
            })
         })
         .catch(err => {
            this.$bvToast.toast( "Blocker Manual konnten nicht vom Server geholt werden.", {
               title: "Sperrlisten-Export",
               autoHideDelay: 8000,
               appendToast: false,
               variant: 'danger'
            });
            console.log(err);  
         })
      }
   },
   created() {
        let promises = [
            ['country', 'market', 'region'].map( s => axios.get(`/mds/${s}`)),
        ].flat();
        Promise.all(promises).then(([_countries, _markets, _regions]) =>
        {
            this.countries = _countries.data;
            this.markets = _markets.data;
            this.regions = _regions.data;
        }).catch(error => {
         this.$bvToast.toast( "Regionen/Länder/Märkte konnten nicht vom Server geholt werden.", {
            title: "Sperrlisten-Export",
            autoHideDelay: 8000,
            appendToast: false,
            variant: 'danger'
         });
         console.error(error);         
        })
      axios.get('/marketaccount/all').then( ({data}) => {
         this.marketAccounts = data;
      }).catch( error => {
         this.$bvToast.toast( "Market Accounts konnten nicht vom Server geholt werden.", {
            title: "Sperrlisten-Export",
            autoHideDelay: 8000,
            appendToast: false,
            variant: 'danger'
         });
         console.error(error);
      });
   }
};
</script>
